import { LoaderCircle } from "lucide-react"

export function LoadingSpinner() {
  return <LoaderCircle className="w-8 h-8 animate-spin" />
}

export function CenterSpinner() {
  return (
    <div className="w-full flex grow items-center justify-center">
      <LoadingSpinner />
    </div>
  )
}
